module.exports = __webpack_public_path__ + "static/media/spinner.a23069a4.svg";